import { render, staticRenderFns } from "./footer-page.vue?vue&type=template&id=4a4f4230&scoped=true&"
import script from "./footer-page.vue?vue&type=script&lang=js&"
export * from "./footer-page.vue?vue&type=script&lang=js&"
import style0 from "./footer-page.vue?vue&type=style&index=0&id=4a4f4230&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4f4230",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VFooter,VForm,VLayout,VRow,VTextField})
